export const paymentTypes = [
  { key: "WALLET_ADJUSTMENT", value: "Wallet Adjustment" },
  { key: "EXTERNAL", value: "External Payment" },
  { key: "INTERNAL", value: "Internal Payment" },
  { key: "BALANCE_TOP_UP", value: "Balance Top Up" },
];

export const paymentStatusMessage = {
  ACTIVE: "Initiated",
  PAID: "Success",
  EXPIRED: "Failed",
  CANCELED: "Cancelled",
  FAILED: "Failed",
  SUCCESS: "Success",
  ERROR: "Failed",
  COMPLETED: "Success",
};

export enum PaymentStatus {
  ACTIVE = "ACTIVE",
  PAID = "PAID",
  EXPIRED = "EXPIRED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  COMPLETED = "COMPLETED",
}

/** Coerces payment status for comparison against {@link PaymentStatus} enums. */
export function normalizePaymentStatus(status?: string): string {
  return (status || "").trim().toUpperCase();
}

export enum PlanStatus {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  PAYMENT_PENDING = "PAYMENT_PENDING",
}

/** Coerces plan status for comparison against {@link PlanStatus} enums. */
export function normalizePlanStatus(status?: string): string {
  return (status || "").trim().toUpperCase();
}

export enum PlanType {
  PREPAID = "PREPAID",
  POSTPAID = "POSTPAID",
}

export enum WalletEnvironment {
  PRODUCTION = "PRODUCTION",
  SANDBOX = "SANDBOX",
}
